import { useEffect } from "react";
import { Route, Routes, useLocation } from "react-router-dom";

import { AppShell } from "../components/AppShell";
import { DataGate } from "../components/DataGate";
import {
  BuildPage, ChangelogPage, EvidencePage, GraphPage, HomePage, LabPage, LayerAgentPage, LearnPage, NotFoundPage,
  SystemPage, WebPlatformAgentPage, WebPlatformPage,
} from "./pages";

export function App() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname]);

  return (
    <AppShell>
      <DataGate>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/graph" element={<GraphPage />} />
          <Route path="/agents/:agentId" element={<LayerAgentPage />} />
          <Route path="/learn" element={<LearnPage />} />
          <Route path="/build" element={<BuildPage />} />
          <Route path="/lab" element={<LabPage />} />
          <Route path="/evidence" element={<EvidencePage />} />
          <Route path="/system" element={<SystemPage />} />
          <Route path="/web-platform" element={<WebPlatformPage />} />
          <Route path="/web-platform/agents/:agentId" element={<WebPlatformAgentPage />} />
          <Route path="/changelog" element={<ChangelogPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </DataGate>
    </AppShell>
  );
}
